/* ==========================================================================
   Vanguarda — correcoes visuais da folha do carrinho.

   Faz duas coisas:
     1. pinta as bolinhas de cor com a COR, nao com a foto da variante
     2. troca a foto assim que a COR e escolhida, sem esperar o tamanho

   A folha e montada em JS a partir de /products/<handle>.js, que nao carrega
   nenhum dado de swatch. Sem paleta, o vg-quick-add.js caiu no unico recurso
   que tinha: a foto da variante. O resultado era um disco com a modelo inteira
   dentro, enquanto a pagina do produto mostrava a cor.

   Este arquivo repinta essas bolinhas com a cor de verdade, usando a MESMA
   paleta de snippets/color-swatch.liquid.

   >>> A tabela abaixo e um espelho daquele snippet. Mudou cor la, muda aqui.
   >>> O snippet continua sendo a fonte para o Liquid; isto e a copia para o JS,
   >>> pelo mesmo motivo que as tabelas de tamanho sao emitidas duas vezes.

   A ORDEM e carregada de sentido, exatamente como no Liquid:
     - especifico antes de generico (Forest Green antes de green)
     - a familia do rosa ANTES de navy, porque a regra de navy casa com 'ink'
       e todo "pink" contem "ink"
     - aqua antes de green, para "Aqua Green" nao virar verde

   Observa #QuickAddBody porque a folha se redesenha inteira a cada troca de
   opcao; sem o observer a cor voltaria para a foto no primeiro clique.

   Degrada honestamente: se este arquivo nao carregar, a folha continua
   funcionando exatamente como antes, com a foto da variante.
   ========================================================================== */
(function () {
  'use strict';

  var PALETTE = [
    [['bone', 'ecru', 'cream', 'natural', 'off white', 'off-white', 'pearl', 'ivory'], '#EFE9DC'],
    [['optic', 'white'], '#FAF8F3'],
    [['oxblood', 'burgundy', 'wine', 'maroon'], '#5A2A32'],
    [['black', 'jet', 'onyx'], '#1A1815'],
    [['charcoal', 'graphite'], '#3B3A37'],
    [['dark grey', 'dark gray'], '#55534E'],
    [['light grey', 'light gray', 'silver', 'pewter'], '#C6C3BC'],
    [['heather', 'grey', 'gray', 'ash', 'slate'], '#9A968D'],
    [['stone', 'sand', 'oat', 'putty', 'beige'], '#D8CDBA'],
    [['taupe', 'mushroom', 'mocha'], '#8B8078'],
    [['camel', 'tan', 'khaki', 'wheat'], '#C2A47E'],
    [['espresso', 'chocolate', 'coffee', 'brown'], '#4A362A'],
    [['apricot', 'peach'], '#E8B48A'],
    [['coral', 'salmon'], '#E08A6E'],
    [['orange', 'tangerine'], '#C9702E'],
    [['clay', 'rust', 'brick', 'terracotta', 'copper'], '#A85A3C'],
    [['blush', 'rose', 'pink', 'watermelon', 'fuchsia', 'magenta'], '#D98BA0'],
    [['lavender', 'lilac'], '#B6A8CB'],
    [['plum', 'aubergine'], '#5A3E55'],
    [['violet', 'purple'], '#6E5A87'],
    [['aqua', 'teal', 'turquoise'], '#4E9A9A'],
    [['mint'], '#A8CFB8'],
    [['sage'], '#9AA88C'],
    [['forest', 'pine', 'hunter'], '#2F4034'],
    [['olive', 'army', 'fatigue', 'military'], '#5C6249'],
    [['emerald', 'kelly', 'green'], '#4A6B4F'],
    [['sky', 'powder', 'light blue'], '#A7C4DC'],
    [['navy', 'midnight', 'ink'], '#22304A'],
    [['dark blue'], '#2B4570'],
    [['denim', 'indigo', 'chambray'], '#64809E'],
    [['blue', 'cobalt'], '#3A5F8A'],
    [['mustard', 'ochre', 'gold', 'amber'], '#C08A2E'],
    [['yellow', 'lemon', 'butter'], '#D9C15C'],
    [['red', 'scarlet', 'cherry'], '#A33A33']
  ];

  /* Um padrao nao e uma cor. Um disco liso para "Leopard" promete uma fibra
     solida que a peca nao tem, entao estes ganham um chip que LE como padrao. */
  var PATTERNS = [
    [['leopard', 'animal', 'cheetah', 'zebra'],
      'linear-gradient(135deg, #C2A47E 0 38%, #4A362A 38% 62%, #C2A47E 62%)'],
    [['stripe', 'pinstripe'],
      'repeating-linear-gradient(45deg, #1A1815 0 3px, #FAF8F3 3px 6px)'],
    [['floral', 'print', 'abstract', 'batik', 'multi', 'camo'],
      'linear-gradient(135deg, #D98BA0 0 33%, #9AA88C 33% 66%, #C2A47E 66%)']
  ];

  function hexFor(part) {
    for (var i = 0; i < PALETTE.length; i++) {
      var keys = PALETTE[i][0];
      for (var k = 0; k < keys.length; k++) {
        if (part.indexOf(keys[k]) !== -1) return PALETTE[i][1];
      }
    }
    return null;
  }

  function resolve(value) {
    var lower = String(value || '').toLowerCase();
    if (!lower) return 'var(--vg-line)';

    /* Divide no '/' para um nome de duas cores resolver as duas metades —
       e o que uma peca vendida como "Red / Navy" realmente parece. */
    var parts = lower.split('/');
    var hits = [];
    for (var i = 0; i < parts.length; i++) {
      var hex = hexFor(parts[i].trim());
      if (hex) hits.push(hex);
    }
    if (hits.length > 1) {
      return 'linear-gradient(135deg, ' + hits[0] + ' 0 50%, ' + hits[1] + ' 50%)';
    }
    if (hits.length === 1) return hits[0];

    for (var p = 0; p < PATTERNS.length; p++) {
      var pk = PATTERNS[p][0];
      for (var j = 0; j < pk.length; j++) {
        if (lower.indexOf(pk[j]) !== -1) return PATTERNS[p][1];
      }
    }

    /* Nome que ninguem previu. Um chip neutro visivel e melhor que um invisivel. */
    return 'var(--vg-line)';
  }

  function isColourLabel(text) {
    return /colou?r|cor\b|colore|farbe/i.test(text || '');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function paint(scope) {
    var groups = scope.querySelectorAll('.qa__opt');
    for (var g = 0; g < groups.length; g++) {
      var label = groups[g].querySelector('.qa__lab b');
      if (!label || !isColourLabel(label.textContent)) continue;

      var vals = groups[g].querySelectorAll('button[data-val]');
      for (var v = 0; v < vals.length; v++) {
        var btn = vals[v];
        if (btn.getAttribute('data-vg-swatch') === '1') continue;

        var name = btn.getAttribute('data-val') || '';
        btn.classList.add('qa__val--sw');
        btn.style.backgroundImage = '';
        btn.style.background = resolve(name);
        btn.setAttribute('aria-label', name);
        btn.setAttribute('title', name);
        /* O nome sai do visual mas continua no acessivel — a bolinha sozinha
           nao diz nada para quem usa leitor de tela. */
        btn.innerHTML = '<span class="visually-hidden">' + esc(name) + '</span>';
        btn.setAttribute('data-vg-swatch', '1');
      }
    }
  }

  /* ------------------------------------------------------------------- foto

     O vg-quick-add.js so resolve a foto quando TODAS as opcoes estao
     escolhidas: ele chama currentVariant(), que devolve null enquanto faltar
     uma. Ate la mostra a foto principal do produto. Na pratica isso quer dizer
     que escolher a cor nao mudava nada — a foto so aparecia depois do tamanho,
     que e a ordem inversa de como as pessoas compram roupa.

     Aqui a foto segue a escolha PARCIAL: assim que a cor e escolhida, procura
     a primeira variante daquela cor que tenha foto propria e usa ela. O
     tamanho fica irrelevante para a imagem, como deve ser.

     Nao entra em laco com o observer porque trocar o src e mudanca de
     atributo, e o observer so escuta childList. */

  function sized(url, w) {
    if (!url) return '';
    return url.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_' + w + 'x$1$2');
  }

  function currentProduct() {
    var reg = window.VGQA;
    if (!reg || !reg.products || !reg.current) return null;
    return reg.products[reg.current] || null;
  }

  /* O que o comprador ja escolheu, por indice de opcao. Lido do proprio DOM
     para nao duplicar o estado que o vg-quick-add.js mantem. */
  function chosenFrom(scope) {
    var out = [];
    var on = scope.querySelectorAll('button[data-val].is-on');
    for (var i = 0; i < on.length; i++) {
      var idx = Number(on[i].getAttribute('data-opt'));
      if (!isNaN(idx)) out[idx] = on[i].getAttribute('data-val');
    }
    return out;
  }

  function photo(scope) {
    var p = currentProduct();
    if (!p || !p.variants) return;

    var img = scope.querySelector('.qa__img');
    if (!img) return;

    var chosen = chosenFrom(scope);
    var any = false;
    for (var c = 0; c < chosen.length; c++) if (chosen[c]) any = true;
    if (!any) return;

    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      var ok = true;
      for (var k = 0; k < chosen.length; k++) {
        if (chosen[k] && v['option' + (k + 1)] !== chosen[k]) { ok = false; break; }
      }
      if (!ok) continue;
      var src = v.featured_image && v.featured_image.src;
      if (!src) continue;
      var next = sized(src, 200);
      if (img.getAttribute('src') !== next) img.setAttribute('src', next);
      return;
    }
  }

  function start() {
    var body = document.getElementById('QuickAddBody');
    if (!body) return;
    paint(body);
    photo(body);
    /* A folha se redesenha inteira a cada troca de opcao, entao nao basta
       rodar uma vez. */
    new MutationObserver(function () { paint(body); photo(body); })
      .observe(body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
